import { mediaQueries } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  ${mediaQueries.tablet} {
    max-width: 177px;
  }
`;
